import { render, staticRenderFns } from "./ordini.vue?vue&type=template&id=34f40f3a&"
import script from "./ordini.vue?vue&type=script&lang=ts&"
export * from "./ordini.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports